import { TaxRoute } from '@/modules/tax/routes/tax.routes';
import Enum from '@/modules/core/app/helpers/Enum';
import { AuthRoute } from '@/modules/auth/routes/auth.routes';

export class UnTrackablePages extends Enum {
  static LOGIN = AuthRoute.LOGIN;
  static PROBATE_TAX_CALCULATOR_EMBED = TaxRoute.PROBATE_TAX_CALCULATOR_EMBED;
}
